export default __webpack_public_path__ + "static/media/longchamp17.7982ba8c.jpg";